import React from "react"
import { translate } from "../../translations/translations"
import { useExpenseForm } from "../../hooks/useExpenseForm"
import { useCalculator } from "../../context/CalculatorContext"
import { AssetTypes } from "../../models/AssetType"
import Button from "../Shared/Button"
import Input from "../Shared/Input"
import styles from "./InputForm.module.css"
import Tooltip from "../Shared/Tooltip"

const ExpenseInput: React.FC<{ onNext: () => void; onBack: () => void }> = ({
  onNext,
  onBack,
}) => {
  const { labels, formErrors, handleChange, handleValidation } =
    useExpenseForm()
  const { shipments, expenses } = useCalculator()
  const assetType = shipments.assetType

  const assetTypeLabel = AssetTypes.find(
    (type) => type.key === assetType,
  )?.labelKey

  const handleNext = () => {
    if (handleValidation()) {
      onNext()
    }
  }

  const isChemical = shipments.assetType === "chemical"
  const filteredLabels = isChemical ? labels.slice(0, 4) : labels

  return (
    <div className={styles.inputFormContainer}>
      <div className={styles.formInnerContainer}>
        <h2 className={styles.formTitle}>
          {assetTypeLabel ? translate(assetTypeLabel) : translate("unknown")}
        </h2>

        {filteredLabels.map(({ key, labelKey }) => (
          <div className={styles.formGroup} key={key}>
            <label htmlFor={key} className={styles.formLabel}>
              {translate(labelKey)}
              <Tooltip text={translate(labelKey, "en", assetType)} />
            </label>
            <div className={styles.inputWrapper}>
              <Input
                id={key}
                type="number"
                min="0"
                unit="$"
                value={expenses.expenses[key] || ""}
                onChange={(e) => handleChange(key, e.target.value)}
              />
              {formErrors[key] && (
                <span className={styles.errorMessage}>{formErrors[key]}</span>
              )}
            </div>
          </div>
        ))}

        <div className={styles.formGroup}>
          <div className={styles.buttonContainer}>
            <Button onClick={onBack} label={translate("back")} />
            <Button onClick={handleNext} label={translate("next")} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ExpenseInput
